export default __webpack_public_path__ + "static/media/counter-bg.4aa6f934.png";